import CNRequest from '@alife/cn-request';
import { getTrace } from 'src/utils/tracker';
import { getAppConfig } from 'src/utils/config';
import { preUrl, prodUrl, dailyUrl } from 'src/utils/const';
const baseUrlMap = {
    prod: prodUrl,
    pre: preUrl,
    daily: dailyUrl,
};
const request = CNRequest({ timeout: 5000 }, {
    armsTrace: getTrace(),
});
request.interceptors.request.use((config) => {
    config.headers = {
        ...config.headers,
    };
    // 由于cainiao.com 下的登录态可能是不同账号体系的 cookie传给后端 会导致后端解析 cookie失败 而导致后端自动清除cookie  影响用户端使用
    // if(!('withCredentials' in config)){
    //   // 当前接口调用 都是跨域 先写死 后期改造时再特殊处理
    //   config.withCredentials = true;
    // }
    const baseUrl = baseUrlMap[getAppConfig()?.env] || baseUrlMap.prod;
    if (!config.url.startsWith('/os')) {
        config.url = `${baseUrl}${config.url}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
request.interceptors.response.use((res) => {
    // console.log('res', res);
    if (res.status == 200 && (res.data?.code === '0000' || res.data?.success)) {
        return res.data.data?.data || res.data.data;
    }
    throw res.data;
});
export default request;
